import React, { useEffect, useMemo, useState } from 'react';
import '../design/MisAreas.css';
import axios from 'axios';
import { API_URL } from '../../config/config';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import L1 from '../../assets/l1.png';
import L2 from '../../assets/l2.png';
import L3 from '../../assets/l3.png';
import Mt from '../../assets/mt.png';
import Cn from '../../assets/cn.png';
import Cs from '../../assets/cs.png';
import Ea from '../../assets/ea.png';
import Fc from '../../assets/fc.png';
import Ef from '../../assets/ef.png';
import Pd from '../../assets/pd.png';

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const MisAreas = ({
  plataforma,
  setPlataformaVisible,
  userId,
  seccion,
  setMisSecciones,
  setMiArea,
  setMiIdArea
}) => {
  const [tituloSeleccionado, setTituloSeleccionado] = useState('');
  const [area, setArea] = useState('');
  const [idArea, setIdArea] = useState('');
  const [botonesVisibles, setBotonesVisibles] = useState(true);

  // ✅ unidad seleccionada (1..10)
  const [unidadNumero, setUnidadNumero] = useState('');
  const [unidadesMax, setUnidadesMax] = useState('4'); // normalmente 4

  // ✅ Loading PDF (UNO SOLO)
  const [isPrinting, setIsPrinting] = useState(false);
  const [printingLabel, setPrintingLabel] = useState('');

  const fetchCiclo = () => {
    switch (seccion.grado.toLowerCase()) {
      case 'primero':
      case 'segundo':
      case 'tercero':
        return setBotonesVisibles(true); // id 1-8
      case 'cuarto':
      case 'quinto':
      case 'sexto':
        return setBotonesVisibles(false); // id 9-18
      default:
        return null;
    }
  };

  useEffect(() => {
    fetchCiclo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const seleccionarTitulo = (titulo) => setTituloSeleccionado(titulo);

  const handleErrorMessage = (message) => {
    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
      style: { fontSize: '15px', border: '1px solid red' }
    });
  };

  const handleSuccessMessage = (message) => {
    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 2500,
      style: { fontSize: '16px', border: '1px solid green' }
    });
  };

  // ✅ Normalizador PDF
  const normalizarParaPdf = (text) => {
    if (text === null || text === undefined) return '';
    return String(text)
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .replace(/☐/g, '[  ]')
      .trim();
  };

  // ✅ Para comparar nombres aunque vengan con acentos/espacios diferentes
  const normalizeKey = (s) => {
    if (!s) return '';
    return String(s)
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
  };

  // ✅ Placeholder cuando un área no tiene registros
  const buildEmptyRows = () => [
    {
      competencia: '',
      indicador: '',
      temas: 'SIN REGISTROS PARA ESTA ÁREA EN ESTA UNIDAD',
      actividades: '',
      aprendizaje: '',
      recursos: '',
      mejoramiento: '',
      herramienta: '',
      fechaentrega: '',
      punteo: ''
    }
  ];

  // ✅ Helpers printing
  const startPrinting = (label) => {
    setIsPrinting(true);
    setPrintingLabel(label || 'Generando PDF...');
  };

  const stopPrinting = () => {
    setIsPrinting(false);
    setPrintingLabel('');
  };

  // ✅ Areas según grado (1-8 o 9-18)
  const areasConfig = useMemo(() => {
    if (botonesVisibles) {
      return [
        { id: 1, titulo: 'Comunicación y Lenguaje L1', img: L1 },
        { id: 2, titulo: 'Comunicación y Lenguaje L2', img: L2 },
        { id: 3, titulo: 'Comunicación y Lenguaje L3', img: L3 },
        { id: 4, titulo: 'Matemáticas', img: Mt },
        { id: 5, titulo: 'Medio Social y Natural', img: Cn },
        { id: 6, titulo: 'Expresión Artística', img: Ea },
        { id: 7, titulo: 'Educación Física', img: Ef },
        { id: 8, titulo: 'Formación Ciudadana', img: Fc }
      ];
    }

    return [
      { id: 9, titulo: 'Comunicación y Lenguaje L1', img: L1 },
      { id: 10, titulo: 'Comunicación y Lenguaje L2', img: L2 },
      { id: 11, titulo: 'Comunicación y Lenguaje L3', img: L3 },
      { id: 12, titulo: 'Matemáticas', img: Mt },
      { id: 13, titulo: 'Ciencias Naturales y Tecnología', img: Cn },
      { id: 14, titulo: 'Ciencias Sociales', img: Cs },
      { id: 15, titulo: 'Expresión Artística', img: Ea },
      { id: 16, titulo: 'Educación Física', img: Ef },
      { id: 17, titulo: 'Formación Ciudadana', img: Fc },
      { id: 18, titulo: 'Productividad y Desarrollo', img: Pd }
    ];
  }, [botonesVisibles]);

  // ✅ Selección de área
  const selectArea = (a) => {
    seleccionarTitulo(a.titulo);
    setArea(a.titulo);
    setIdArea(a.id);
  };

  // ============================================================
  // ✅ PEDIR REPORTE POR "NÚMERO DE UNIDAD" (1..10) QUE TRAE TODAS ÁREAS
  // ============================================================
  const fetchReportePorNumeroUnidad = async (unidad) => {
    const grado = seccion.grado;
    let endpoint = null;

    switch (grado) {
      case 'Primero':
        endpoint = `${API_URL}/reportesPrimeroPorNumeroUnidad/${unidad}`;
        break;
      case 'Segundo':
        endpoint = `${API_URL}/reportesSegundoPorNumeroUnidad/${unidad}`;
        break;
      case 'Tercero':
        endpoint = `${API_URL}/reportesTerceroPorNumeroUnidad/${unidad}`;
        break;
      case 'Cuarto':
        endpoint = `${API_URL}/reportesCuartoPorNumeroUnidad/${unidad}`;
        break;
      case 'Quinto':
        endpoint = `${API_URL}/reportesQuintoPorNumeroUnidad/${unidad}`;
        break;
      case 'Sexto':
        endpoint = `${API_URL}/reportesSextoPorNumeroUnidad/${unidad}`;
        break;
      default:
        return null;
    }

    const resp = await axios.get(endpoint, {
      params: {
        id_docente: userId,
        id_ciclo: seccion.id_ciclo,
        id_grado: seccion.id_grado,
        id_seccion: seccion.id_seccion
      }
    });

    return resp.data;
  };

  // ============================================================
  // ✅ Firmas dinámicas según si el docente es director
  // ✅ CAMBIO IMPORTANTE:
  //    - Detecta "director" en múltiples formatos (true/false, 1/0, "SI/NO", etc.)
  //    - Si ES director:
  //        * derecha nombre = CTAE
  //        * derecha cargo  = "C. T. A. E. <distrito>"
  //        * izquierda cargo = "Director con grados"
  // ============================================================
  const buildFirmasData = (encabezadoBase, nombreDocente) => {
  const isTrueLike = (v) => {
    if (v === true) return true;
    if (v === false || v === null || v === undefined) return false;
    const s = String(v).trim().toLowerCase();
    return s === 'si' || s === 'sí' || s === 's' || s === '1' || s === 'true' || s === 'yes';
  };

  // ✅ OJO: "esdirector" viene de tu VIEW (d.director as esdirector)
  // ❌ NO usar encabezadoBase.director porque ese es el NOMBRE del director del establecimiento (e.director)
  const esDirector = isTrueLike(
    encabezadoBase.es_director ??
      encabezadoBase.esdirector ?? // ✅ clave correcta
      encabezadoBase.director_docente ??
      encabezadoBase.docente_director ??
      encabezadoBase.is_director ??
      encabezadoBase.director_flag
  );

  const nombreDirector = (encabezadoBase.director || '').trim(); // nombre director establecimiento
  const nombreCtae = (encabezadoBase.ctae || '').trim();
  const distritoTexto = (encabezadoBase.distrito || '').trim();

  const izquierdaNombre = nombreDocente;
  const izquierdaCargo = esDirector ? 'Director con grados' : 'Docente';

  const derechaNombre = esDirector ? nombreCtae : nombreDirector;
  const derechaCargo = esDirector
    ? `C. T. A. E.${distritoTexto ? ` ${distritoTexto}` : ''}`
    : 'Director(a)';

  return {
    izquierda: { nombre: izquierdaNombre, cargo: izquierdaCargo },
    derecha: { nombre: derechaNombre, cargo: derechaCargo }
  };
};


  // ============================================================
  // ✅ PDF helpers (márgenes 0.7cm + keep together + footer)
  // ============================================================
  const getPdfLayout = () => ({
    top: 0.7,
    right: 0.7,
    bottom: 1.1,
    left: 0.7,

    titleSize1: 13,
    titleSize2: 13,
    headerFont: 11,
    tableFont: 10,
    lineWidth: 0.01,

    gapSmall: 0.3,
    gapMed: 0.45,
    gapBig: 0.65
  });

  const formatDateDisplay = (value) => {
    if (!value) return '';
    const v = String(value);
    const iso = v.includes('T') ? v.split('T')[0] : v;
    const [year, month, day] = iso.split('-');
    if (!year || !month || !day) return v;
    return `${day}/${month}/${year}`;
  };

  const ensureSpace = (doc, currentY, neededHeight, layout) => {
    const pageH = doc.internal.pageSize.getHeight();
    const limit = pageH - layout.bottom;
    if (currentY + neededHeight > limit) {
      doc.addPage();
      return layout.top;
    }
    return currentY;
  };

  const centeredText = (doc, text, y) => {
    const textWidth =
      (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) / doc.internal.scaleFactor;
    const x = (doc.internal.pageSize.getWidth() - textWidth) / 2;
    doc.text(text, x, y);
  };

  const buildNombreDocente = (encabezadoBase) => {
    return `${encabezadoBase.primer_nombre || ''} ${encabezadoBase.segundo_nombre || ''} ${
      encabezadoBase.otros_nombres || ''
    } ${encabezadoBase.primer_apellido || ''} ${encabezadoBase.segundo_apellido || ''}`.trim();
  };

  // ✅ Footer:
  // - Izquierda: nombre del docente
  // - Derecha: PRIMERO establecimiento y luego dirección (sin etiquetas)
  // - Sin línea
  const drawFooter = (doc, encabezadoBase, nombreDocente, layout) => {
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const y = pageH - layout.bottom + 0.45;
    const leftX = layout.left;
    const rightX = pageW - layout.right;

    const establecimiento = (encabezadoBase.establecimiento || '').trim();
    const direccion = `${encabezadoBase.direccion || ''}, ${encabezadoBase.municipio || ''}, ${
      encabezadoBase.departamento || ''
    }`.trim();

    const rightText = [establecimiento, direccion].filter(Boolean).join(' · ');

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);

    doc.text(nombreDocente || '', leftX, y);

    const maxRightWidth = rightX - pageW * 0.45;
    const lines = doc.splitTextToSize(rightText, maxRightWidth);
    doc.text(lines[0] || '', rightX, y, { align: 'right' });
  };

  const autoTableHeadSoloPrimera = ({
    doc,
    headRow,
    bodyRows,
    startY,
    layout,
    headFillColor = [173, 216, 230],
    fontSize = 10,
    columnStyles = {},
    footerData
  }) => {
    const body = [headRow, ...bodyRows];

    doc.autoTable({
      body,
      startY,
      theme: 'grid',
      margin: { left: layout.left, right: layout.right },
      styles: {
        textColor: [0, 0, 0],
        lineWidth: 0.01,
        lineColor: [0, 0, 0],
        fontSize,
        overflow: 'linebreak',
        valign: 'top',
        cellPadding: 0.12
      },
      columnStyles,

      didDrawPage: () => {
        if (footerData) {
          drawFooter(doc, footerData.encabezadoBase, footerData.nombreDocente, layout);
        }
      },

      didParseCell: (d) => {
        const isFirstRow = d.row.index === 0;
        const isFirstPage = d.table.pageNumber === 1;

        if (isFirstRow && isFirstPage) {
          d.cell.styles.fillColor = headFillColor;
          d.cell.styles.textColor = [0, 0, 0];
          d.cell.styles.valign = 'middle';
          d.cell.styles.halign = 'center';
          d.cell.styles.fontStyle = 'bold';
          d.cell.styles.cellPadding = 0.18;
          d.cell.styles.minCellHeight = 0.6;
        }

        if (isFirstRow && !isFirstPage) {
          d.cell.styles.fillColor = [255, 255, 255];
          d.cell.styles.textColor = [255, 255, 255];
          d.cell.styles.lineWidth = 0;
          d.cell.text = '';
          d.cell.styles.minCellHeight = 0;
          d.cell.styles.cellPadding = 0;
        }
      }
    });
  };

  const renderFirmasCompactas = (doc, posY, firmasData, layout, footerData) => {
    const blockH = 1.9;
    const before = posY;
    posY = ensureSpace(doc, posY, blockH, layout);

    if (posY !== before && footerData) {
      drawFooter(doc, footerData.encabezadoBase, footerData.nombreDocente, layout);
    }

    const pageW = doc.internal.pageSize.getWidth();
    const usableW = pageW - layout.left - layout.right;

    const leftCenterX = layout.left + usableW * 0.25;
    const rightCenterX = layout.left + usableW * 0.75;

    const lineHalf = 4.2;
    const lineY = posY + 0.25;

    doc.setLineWidth(layout.lineWidth);

    doc.line(leftCenterX - lineHalf, lineY, leftCenterX + lineHalf, lineY);
    doc.line(rightCenterX - lineHalf, lineY, rightCenterX + lineHalf, lineY);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12);

    doc.text(firmasData.izquierda.nombre || '', leftCenterX, lineY + 0.55, { align: 'center' });
    doc.text(firmasData.derecha.nombre || '', rightCenterX, lineY + 0.55, { align: 'center' });

    doc.setFontSize(11);
    doc.text(firmasData.izquierda.cargo || '', leftCenterX, lineY + 1.05, { align: 'center' });
    doc.text(firmasData.derecha.cargo || '', rightCenterX, lineY + 1.05, { align: 'center' });

    return lineY + 1.3;
  };

  // ============================================================
  // ✅ Render de UNA hoja (un área)
  // ============================================================
  const renderAreaPage = ({
    doc,
    encabezadoBase,
    unidadNumeroLocal,
    nombreArea,
    rows,
    isFirstPageOfDoc
  }) => {
    const layout = getPdfLayout();

    if (!isFirstPageOfDoc) doc.addPage();

    let posY = layout.top;

    const nombreDocente = buildNombreDocente(encabezadoBase);
    const footerData = { encabezadoBase, nombreDocente };

    // ✅ Footer de la página actual
    drawFooter(doc, encabezadoBase, nombreDocente, layout);

    // Logo
    if (encabezadoBase.logotipo) {
      const imgWidth = 0.9;
      const imgHeight = 0.9;
      const xImg = (doc.internal.pageSize.getWidth() - imgWidth) / 2;
      doc.addImage(encabezadoBase.logotipo, 'JPEG', xImg, posY, imgWidth, imgHeight);
      posY += imgHeight + layout.gapSmall;
    } else {
      posY += 0.1;
    }

    posY += 0.2;

    doc.setFontSize(layout.titleSize1);
    doc.setFont('helvetica', 'bold');
    centeredText(doc, `PLANIFICACIÓN ESCOLAR ${encabezadoBase.ciclo}`, posY);
    posY += 0.55;

    doc.setFontSize(layout.headerFont);
    doc.setLineWidth(layout.lineWidth);

    const lineBaseY = posY + 0.08;

    const writeField = (label, value, xLabel, xValue, y, xLineFrom, xLineTo) => {
      doc.setFont('helvetica', 'bold');
      doc.text(label, xLabel, y);
      doc.setFont('helvetica', 'normal');
      doc.text(value || '', xValue, y);
      doc.line(xLineFrom, y + 0.1, xLineTo, y + 0.1);
    };

    writeField(
      'Nombre del Establecimiento:',
      encabezadoBase.establecimiento || '',
      layout.left,
      7.25,
      posY,
      7.25,
      26.6
    );
    posY += 0.6;

    writeField(
      'Dirección del Establecimiento:',
      `${encabezadoBase.direccion || ''}, ${encabezadoBase.municipio || ''}, ${
        encabezadoBase.departamento || ''
      }`,
      layout.left,
      7.25,
      posY,
      7.25,
      26.6
    );
    posY += 0.6;

    doc.setFont('helvetica', 'bold');
    doc.text('Director:', layout.left, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.director || ''}`, 3.0, posY);
    doc.line(3.0, lineBaseY + 1.2, 13.0, lineBaseY + 1.2);

    doc.setFont('helvetica', 'bold');
    doc.text('Ciclo Escolar:', 13.5, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.ciclo || ''}`, 16.5, posY);
    doc.line(16.5, lineBaseY + 1.2, 18.5, lineBaseY + 1.2);

    doc.setFont('helvetica', 'bold');
    doc.text('Jornada:', 19.0, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.jornada || ''}`, 21.0, posY);
    doc.line(21.0, lineBaseY + 1.2, 26.6, lineBaseY + 1.2);

    posY += 0.6;

    doc.setFont('helvetica', 'bold');
    doc.text('Docente:', layout.left, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(nombreDocente, 3.0, posY);
    doc.line(3.0, lineBaseY + 1.8, 13.0, lineBaseY + 1.8);

    doc.setFont('helvetica', 'bold');
    doc.text('Grado:', 13.5, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.grado || ''}`, 15.0, posY);
    doc.line(15.0, lineBaseY + 1.8, 18.5, lineBaseY + 1.8);

    doc.setFont('helvetica', 'bold');
    doc.text('Sección:', 19.0, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.seccion || ''}`, 21.0, posY);
    doc.line(21.0, lineBaseY + 1.8, 22.5, lineBaseY + 1.8);

    doc.setFont('helvetica', 'bold');
    doc.text('Unidad:', 23.0, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${unidadNumeroLocal}`, 24.6, posY);
    doc.line(24.6, lineBaseY + 1.8, 26.6, lineBaseY + 1.8);

    posY += 0.6;

    doc.setFont('helvetica', 'bold');
    doc.text('Área:', layout.left, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${nombreArea}`, 2.1, posY);
    doc.line(2.1, lineBaseY + 2.4, 11.0, lineBaseY + 2.4);

    doc.setFont('helvetica', 'bold');
    doc.text('Tipo:', 11.5, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${encabezadoBase.tipo || ''}`, 13.0, posY);
    doc.line(13.0, lineBaseY + 2.4, 18.5, lineBaseY + 2.4);

    const fechaDelFormateada = formatDateDisplay(encabezadoBase.fechadel);
    doc.setFont('helvetica', 'bold');
    doc.text('Del:', 19.0, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${fechaDelFormateada}`, 20.0, posY);
    doc.line(20.0, lineBaseY + 2.4, 22.5, lineBaseY + 2.4);

    const fechaAlFormateada = formatDateDisplay(encabezadoBase.fechaal);
    doc.setFont('helvetica', 'bold');
    doc.text('Al:', 23.0, posY);
    doc.setFont('helvetica', 'normal');
    doc.text(`${fechaAlFormateada}`, 23.8, posY);
    doc.line(23.8, lineBaseY + 2.4, 26.6, lineBaseY + 2.4);

    posY += layout.gapBig;

    const minForTitleAndTable1 = 2.2;
    posY = ensureSpace(doc, posY, minForTitleAndTable1, layout);

    doc.setFontSize(layout.titleSize2);
    doc.setFont('helvetica', 'bold');
    centeredText(doc, 'PLANIFICACIÓN DE CONTENIDOS', posY);
    posY += 0.42;

    const headRow1 = [
      'No.',
      'Competencia',
      'Indicador de Logro',
      'Temas y Subtemas',
      'Actividades de Aprendizaje',
      'Actividades de Evaluación',
      'Recursos'
    ];

    const bodyRows1 = rows.map((fila, index) => [
      index + 1,
      fila.competencia,
      fila.indicador,
      fila.temas,
      fila.actividades,
      fila.aprendizaje,
      fila.recursos
    ]);

    autoTableHeadSoloPrimera({
      doc,
      headRow: headRow1,
      bodyRows: bodyRows1,
      startY: posY,
      layout,
      fontSize: layout.tableFont,
      footerData
    });

    posY = doc.autoTable.previous.finalY + 0.55;

    const minForTitleAndTable2 = 2.2;
    posY = ensureSpace(doc, posY, minForTitleAndTable2, layout);

    doc.setFontSize(layout.titleSize2);
    doc.setFont('helvetica', 'bold');
    centeredText(doc, 'PLANIFICACIÓN DE ACTIVIDADES DE EVALUACIÓN Y MEJORAMIENTO', posY);
    posY += 0.42;

    const headRow2 = [
      'No.',
      'Temas',
      'Actividades de Aprendizaje',
      'Actividades de Mejoramiento',
      'Herramienta',
      'Fecha',
      'Punteo'
    ];

    const bodyRows2 = rows.map((fila, index) => [
      index + 1,
      fila.temas,
      fila.aprendizaje,
      fila.mejoramiento,
      normalizarParaPdf(fila.herramienta),
      fila.fechaentrega ? formatDateDisplay(fila.fechaentrega) : '',
      fila.punteo
    ]);

    autoTableHeadSoloPrimera({
      doc,
      headRow: headRow2,
      bodyRows: bodyRows2,
      startY: posY,
      layout,
      fontSize: layout.tableFont,
      columnStyles: {
        0: { cellWidth: 1.0 },
        1: { cellWidth: 3.8 },
        2: { cellWidth: 7.0 },
        3: { cellWidth: 6.0 },
        4: { cellWidth: 4.0 },
        5: { cellWidth: 3.0 },
        6: { cellWidth: 1.8 }
      },
      footerData
    });

    posY = doc.autoTable.previous.finalY + 0.7;

    // ✅ APLICA A AMBOS PDF (ambos pasan por renderAreaPage)
    const firmasData = buildFirmasData(encabezadoBase, nombreDocente);
    renderFirmasCompactas(doc, posY, firmasData, layout, footerData);
  };

  // ============================================================
  // ✅ PDF: TODAS LAS ÁREAS DE UNA UNIDAD
  // ============================================================
  const generarPdfTodasLasAreasDeUnidad = async () => {
    if (!unidadNumero) {
      handleErrorMessage('Selecciona la unidad (1-10) a imprimir.');
      return;
    }

    startPrinting(`Generando PDF de Unidad ${unidadNumero}...`);

    try {
      const data = await fetchReportePorNumeroUnidad(unidadNumero);

      if (!data || !data.encabezado || !Array.isArray(data.datosTabla)) {
        handleErrorMessage('No hay datos para generar el PDF.');
        return;
      }

      const agrupadoPorArea = {};
      for (const row of data.datosTabla) {
        const key = normalizeKey(row.area) || 'sin area';
        if (!agrupadoPorArea[key]) agrupadoPorArea[key] = [];
        agrupadoPorArea[key].push(row);
      }

      const areasOrdenadas = areasConfig.map((a) => a.titulo);
      const encabezadoBase = data.encabezado;

      const layout = getPdfLayout();

      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'cm',
        format: 'letter',
        margins: { top: layout.top, right: layout.right, bottom: layout.bottom, left: layout.left }
      });

      areasOrdenadas.forEach((nombreArea, idx) => {
        startPrinting(`Unidad ${unidadNumero} · Área ${idx + 1}/${areasOrdenadas.length}...`);

        const key = normalizeKey(nombreArea);
        const rows =
          agrupadoPorArea[key] && agrupadoPorArea[key].length ? agrupadoPorArea[key] : buildEmptyRows();

        renderAreaPage({
          doc,
          encabezadoBase,
          unidadNumeroLocal: unidadNumero,
          nombreArea,
          rows,
          isFirstPageOfDoc: idx === 0
        });
      });

      doc.save(`planificacion_${seccion.grado}_unidad_${unidadNumero}_todas_las_areas.pdf`);
      handleSuccessMessage('PDF generado con éxito.');
    } catch (err) {
      console.error(err);
      handleErrorMessage('Error al generar el PDF (revisa que exista el endpoint por número de unidad).');
    } finally {
      stopPrinting();
    }
  };

  // ============================================================
  // ✅ PDF: UNIDADES 1..N, cada unidad y cada área en hoja nueva
  // ============================================================
  const generarPdfTodasUnidadesTodasLasAreas = async () => {
    const max = parseInt(unidadesMax || '0', 10);
    if (!max || max < 1) {
      handleErrorMessage('Selecciona cuántas unidades imprimir (ej. 4).');
      return;
    }

    startPrinting(`Generando PDF Unidades 1-${max}...`);

    try {
      const layout = getPdfLayout();

      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'cm',
        format: 'letter',
        margins: { top: layout.top, right: layout.right, bottom: layout.bottom, left: layout.left }
      });

      const ordenAreas = areasConfig.map((a) => a.titulo);

      let firstPage = true;

      for (let u = 1; u <= max; u++) {
        startPrinting(`Cargando datos de Unidad ${u}/${max}...`);

        const data = await fetchReportePorNumeroUnidad(u);

        if (!data || !data.encabezado || !Array.isArray(data.datosTabla)) {
          toast.info(`Unidad ${u}: sin datos (se omitió).`, { autoClose: 1800 });
          continue;
        }

        const encabezadoBase = data.encabezado;

        const agrupadoPorArea = {};
        for (const row of data.datosTabla) {
          const key = normalizeKey(row.area) || 'sin area';
          if (!agrupadoPorArea[key]) agrupadoPorArea[key] = [];
          agrupadoPorArea[key].push(row);
        }

        for (let i = 0; i < ordenAreas.length; i++) {
          const nombreArea = ordenAreas[i];
          startPrinting(`Unidad ${u}/${max} · Área ${i + 1}/${ordenAreas.length}...`);

          const key = normalizeKey(nombreArea);
          const rows =
            agrupadoPorArea[key] && agrupadoPorArea[key].length ? agrupadoPorArea[key] : buildEmptyRows();

          renderAreaPage({
            doc,
            encabezadoBase,
            unidadNumeroLocal: u,
            nombreArea,
            rows,
            isFirstPageOfDoc: firstPage
          });

          firstPage = false;
        }
      }

      doc.save(`planificacion_${seccion.grado}_unidades_1_a_${max}_todas_las_areas.pdf`);
      handleSuccessMessage('PDF generado con todas las unidades.');
    } catch (err) {
      console.error(err);
      handleErrorMessage('Error al generar el PDF de todas las unidades.');
    } finally {
      stopPrinting();
    }
  };

  return (
    <section className="Areas" id="Areas">
      <ToastContainer />

      <div className="header">
        <span className="material-icons-sharp header-span title-span">hive</span>
        <h1>Mis Areas y Subáreas</h1>
      </div>

      <div className="areas-titulo">
        <h1>
          {seccion.grado} {seccion.seccion}
        </h1>
        <h2>Selecciona un Área o Subárea:</h2>
      </div>

      <div className="areas-container">
        <div className="areas">
          {areasConfig.map((a) => (
            <div key={a.id} onClick={() => selectArea(a)}>
              <img src={a.img} alt={a.titulo} className="areas-logo" />
              {a.titulo}
            </div>
          ))}
        </div>

        <div className="titulos">
          <h1>{tituloSeleccionado}</h1>

          <div style={{ marginTop: '0.8rem' }}>
            <select
              value={unidadNumero}
              onChange={(e) => setUnidadNumero(e.target.value)}
              style={{
                width: '100%',
                height: '3rem',
                fontSize: '16px',
                borderRadius: '8px',
                padding: '0 0.8rem',
                border: '1px solid #000'
              }}
              disabled={isPrinting}
            >
              <option value="" disabled>
                Selecciona unidad a imprimir (1-10)...
              </option>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                <option key={n} value={String(n)}>
                  Unidad {n}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginTop: '0.8rem' }}>
            <select
              value={unidadesMax}
              onChange={(e) => setUnidadesMax(e.target.value)}
              style={{
                width: '100%',
                height: '3rem',
                fontSize: '16px',
                borderRadius: '8px',
                padding: '0 0.8rem',
                border: '1px solid #000',
                marginTop: '0.6rem'
              }}
              disabled={isPrinting}
            >
              <option value="4">Imprimir 4 unidades (normal)</option>
              <option value="3">Imprimir 3 unidades</option>
              <option value="2">Imprimir 2 unidades</option>
              <option value="1">Imprimir 1 unidad</option>
              <option value="10">Imprimir 10 unidades</option>
            </select>
          </div>

          <div className="botones">
            <button
              className="btn-accion"
              disabled={isPrinting}
              onClick={() => {
                if (!area) {
                  handleErrorMessage('Selecciona un área o subárea antes de continuar.');
                  return;
                }
                setPlataformaVisible('plataformaMisTemas');
                setMisSecciones(seccion);
                setMiArea(area);
                setMiIdArea(idArea);
              }}
            >
              Temas
            </button>

            <button
              className="btn-accion"
              disabled={isPrinting}
              onClick={() => {
                if (!area) {
                  handleErrorMessage('Selecciona un área o subárea antes de continuar.');
                  return;
                }
                setPlataformaVisible('plataformaUnidades');
                setMisSecciones(seccion);
                setMiArea(area);
                setMiIdArea(idArea);
              }}
            >
              Planificación
            </button>

            <button
              className="btn-accion btn-pdf"
              onClick={generarPdfTodasLasAreasDeUnidad}
              disabled={isPrinting}
              title="Genera un PDF para la unidad seleccionada con todas las áreas (cada área en página nueva)"
            >
              {isPrinting ? printingLabel || 'Generando PDF...' : 'Todas las Áreas (PDF)'}
            </button>

            <button
              className="btn-accion btn-year"
              onClick={generarPdfTodasUnidadesTodasLasAreas}
              disabled={isPrinting}
              title="PDF con unidades 1..N y todas las áreas por unidad"
            >
              {isPrinting ? printingLabel || 'Generando PDF...' : `PDF Unidades 1-${unidadesMax}`}
            </button>
          </div>

          {isPrinting && (
            <p style={{ marginTop: '0.6rem', fontWeight: 700, fontSize: '15px' }}>
              {printingLabel}
            </p>
          )}
        </div>
      </div>

      <div className="areas-sub">
        <h1>Currículum Nacional Base</h1>
      </div>
    </section>
  );
};

export default MisAreas;
